import { takeEvery, put, call, select } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import get from 'lodash/get';
import { consts as logout } from './logout';
import { consts as signup } from './signup/signup-req';
import { consts as settings } from '../board/settings';
import { consts as filters } from '../board/filters';
import { consts as replies } from '../board/replies';
import { consts as chatConnection } from '../chatConnection';
import { clearLocalStorage } from '../persistent-state';
import { loginReferrerConsts } from '../reducers';
import * as theme from '../ui/theme';
import { REDIRECT_TO_PAGE } from '../../constants/storageKeys';
import { selectLocationBeforeTransitions } from '../healthboard/patientPortal/selectors';
import { LOGIN } from '../../constants/routes';
import { checkIsPaperworkRoute } from '../../utils/paperwork';

function* logoutSagaWorker() {
  yield put({ type: chatConnection.DISCONNECT });
  yield put({ type: settings.CLEAR });
  yield put({ type: filters.CLEAR });
  yield put({ type: logout.CLEAR });
  yield put({ type: loginReferrerConsts.CLEAR_LOGIN_REFERRER });
  yield put({ type: replies.CLEAR });
  yield put({ type: theme.consts.SET_DEFAULT });

  const { isPaperworkRoute } = checkIsPaperworkRoute();
  // Preserve the paperwork token when logging out from a regular-app tab so
  // that a concurrently open paperwork tab is not disrupted.
  clearLocalStorage({ preservePaperwork: !isPaperworkRoute });
}

let shouldSaveDataOnce = true;

function* handleLogout({ payload }) {
  const locationBeforeTransitions = yield select(
    selectLocationBeforeTransitions,
  );

  const pathname = get(locationBeforeTransitions, 'pathname', '');
  const search = get(locationBeforeTransitions, 'search', '');

  yield call(logoutSagaWorker);

  if (pathname && shouldSaveDataOnce && !payload) {
    window.storage.setItem(REDIRECT_TO_PAGE, `${pathname}${search}`);
    shouldSaveDataOnce = false;
  }

  const { isPaperworkRoute, route } = checkIsPaperworkRoute();

  yield call(() => browserHistory.push(isPaperworkRoute ? route : LOGIN));
}

export default function* logoutSaga() {
  yield takeEvery([signup.SEND], logoutSagaWorker);
  yield takeEvery(
    [logout.SUCCEED, logout.REJECTED, logout.ERROR_ENCOUNTERED],
    handleLogout,
  );
}



// WEBPACK FOOTER //
// ./src/redux/auth/logoutSaga.js